/**
 * author: Soumya Shreyas
 */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { ProgressBar, OverlayTrigger, Tooltip } from "react-bootstrap";

import { BiHome, BiPhone, BiMailSend } from "react-icons/bi";

import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import Utils from "../../../core/utilities/Utils";
const ProfileCompletenessBox = ({ t, profileStatus }) => {
  const pendingItems = profileStatus.pendingItems;
  return (
    <div className="border-top p-3 Profile_CompletenessBox">
      <h6>{t("ProfileCompleteness.label")}</h6>
      <div className="prograss_bar pt-2">
        <OverlayTrigger
          placement="top"
          overlay={Utils.renderTooltip(pendingItems?.map((item, idx) =>  <div key={item}>{item}</div>))}
        >
          <ProgressBar variant="success" now={profileStatus.percentage} />
        </OverlayTrigger>
      </div>
      <h6 className="text-center pt-1">{profileStatus.percentage}%</h6>
    </div>
  );
};
export default withTranslation()(ProfileCompletenessBox);
